// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd436752","667":"235b00c1"}[chunkId] + ".chunk.js";
};